// extracted by mini-css-extract-plugin
export default {"menu-item":"MaFAfvXKORU2N4r","active":"O67tGAFEnQaDoSW","icon":"UZsHa7s2LjxngVT"};